import { render } from "./pages-header-selector.vue?vue&type=template&id=a26ae2ae&scoped=true"
import script from "./pages-header-selector.vue?vue&type=script&lang=js"
export * from "./pages-header-selector.vue?vue&type=script&lang=js"

import "./pages-header-selector.vue?vue&type=style&index=0&id=a26ae2ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a26ae2ae"]])

export default __exports__